export default __webpack_public_path__ + "static/media/icon-eletric.24e6f581.svg";